import { Tablet } from './tablet';

export class Location_Inspection {
  id: number;
  company_Id = '';
  company = '';
  location = '';
  price = '';
  locationId: number;
  job_No = '';
  purchaseOrder = '';
  startTime;
  endTime;
  job_Type = 1;
  completed: boolean;
  fullDay: boolean;
  halfDay: boolean;
  otherDay: boolean;
  notes: string;
  users: Tablet[] = [];
  scheduled_Date;
  scheduled_End_Date;
  contactName;
  contactDetails;
  officeContactName;
  officeContactDetails;
  is_edit = false;
  engineerIds: number[] = []
  colour_ID: number;
  //why
  //client_Id: string;
}
